import { AssetType, MetaType } from "../types"
import { actionCreatorGuard, reducerGuard } from "../reducers"

const kind = "assets"

export type Asset = {
  kind: typeof kind
  version: number
  type: AssetType
  name: string
  meta: MetaType
  altText: string
  duration?: number
  muxData?: Record<string, any>
}

export const reducerAction = {
  meta: actionCreatorGuard<Asset, MetaType>("meta", kind),
  type: actionCreatorGuard<Asset, AssetType>("type", kind),
  name: actionCreatorGuard<Asset, string>("name", kind),
  altText: actionCreatorGuard<Asset, string>("altText", kind),
  duration: actionCreatorGuard<Asset, number | undefined>("duration", kind),
  muxData: actionCreatorGuard<Asset, Record<string, any> | undefined>("muxData", kind)
}

// Type safety to ensure we have a defined action for each property
type ReducerActions = {
  [key in keyof Omit<Asset, "kind" | "version">]: (typeof reducerAction)[key][0]
}

// Our exported actions
export const assetAction = Object.fromEntries(
  Object.entries(reducerAction).map(k => [k[0], k[1][0]])
) as ReducerActions

export const assetReducer = reducerGuard<Asset>(kind)
  .case(...reducerAction.meta)
  .case(...reducerAction.type)
  .case(...reducerAction.name)
  .case(...reducerAction.altText)
  .case(...reducerAction.duration)
  .case(...reducerAction.muxData)
  .build()
